interface ActiveHistoryToggleProps {
  showHistory: boolean
  onToggle: (showHistory: boolean) => void
}

export default function ActiveHistoryToggle({ showHistory, onToggle }: ActiveHistoryToggleProps) {
  return (
    <div className="flex gap-1 p-1 bg-gray-100 dark:bg-gray-800 rounded-lg">
      <button
        onClick={() => onToggle(false)}
        className={`px-4 py-2 text-sm font-medium rounded-md cursor-pointer transition-colors ${
          !showHistory
            ? 'bg-white dark:bg-gray-700 text-blue-600 dark:text-blue-400 shadow-sm'
            : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
        }`}
      >
        Aktiv
      </button>
      <button
        onClick={() => onToggle(true)}
        className={`px-4 py-2 text-sm font-medium rounded-md cursor-pointer transition-colors ${
          showHistory
            ? 'bg-white dark:bg-gray-700 text-blue-600 dark:text-blue-400 shadow-sm'
            : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
        }`}
      >
        History
      </button>
    </div>
  )
}